import * as React from 'react';
import { NameEmailModalView, NameEmailModalViewProps } from './NameEmailModal.view';
import { useUserData } from '../../../hooks/useUserData';
import { useState } from 'react';
import { RegisterOptions, useForm, UseFormReturn } from 'react-hook-form';
import { FormOptions, ValidationPatterns } from '../../../constants/form';
import { ValidationMessages } from '../../../constants/validation-messages';
import { ApolloError } from '@apollo/client';
import { ChangeNameEmailMutationFn } from '../../../models/graphql';
import { remapApolloErrors } from '../../../helpers/remapApolloErrors';
import { showToast } from '../../../helpers/showToast';
import { SubmitHandler } from 'react-hook-form/dist/types/form';

export type NameEmailModalControllerProps = Omit<
  NameEmailModalViewProps,
  'onSubmit' | 'submitted' | 'useFormInstance' | 'nameRules' | 'emailRules'
> & {
  changeNameEmailMutation: ChangeNameEmailMutationFn;
};

export const NameEmailModalController = (props: NameEmailModalControllerProps): JSX.Element => {
  const { userData } = useUserData();
  const [submitted, setSubmitted] = useState<boolean>(false);
  const defaultFormValues = { name: userData?.firstName || '', email: userData?.email || '' };
  const useFormInstance: UseFormReturn = useForm({
    ...FormOptions,
    defaultValues: defaultFormValues
  });

  const onSubmit: SubmitHandler<{ name: string; email: string }> = (data: { name: string; email: string }, ev) => {
    ev?.preventDefault();
    setSubmitted(true);
    props
      .changeNameEmailMutation({ variables: { name: data.name, email: data.email, userId: userData?.id } })
      .catch(e => {
        const errorForRemapping = e as ApolloError;
        const mappedError = remapApolloErrors(errorForRemapping);
        showToast({
          summary: 'Error in changing your details',
          detail: mappedError,
          severity: 'error'
        });
        setSubmitted(false);
      });
  };

  const nameRules: RegisterOptions = {
    required: ValidationMessages.name.required
  };

  const emailRules: RegisterOptions = {
    required: ValidationMessages.email.required,
    pattern: {
      value: ValidationPatterns.email,
      message: ValidationMessages.email.invalid
    }
  };

  const viewProps: NameEmailModalViewProps = {
    ...props,
    onSubmit,
    submitted,
    useFormInstance,
    nameRules,
    emailRules
  };

  return <NameEmailModalView {...viewProps} />;
};
